import { useContext, useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router";
import {
  CardAndButtonWrapper,
  HomeLatestThemesPreviewContainer,
  ThemesPreviewContainer,
} from "./HomeLatestThemesPreview.styles";
import EncarteCard from "../../sharable/EncarteCard";
import Loading from "../../sharable/Loading";
import Button from "../../sharable/ActionButton";
import Encarte from "../../../OBJRep/Encarte";
import useCreateEncarte from "../../sharable/hooks/useCreateEncarte";
import Notification from "../../sharable/Notification";
import { useDeviceType } from "../../sharable/hooks/useDeviceType";
import useFetchLatestThemes from "../../WorkSpace/ToolBarMenuViews/ThemesMenuView.jsx/hooks/useFetchLatestThemes";

export default function HomeLatestThemesPreview() {
  const { token, accountStatus, isAccountPremium } = useOutletContext();
  const [notification, setNotification] = useState(undefined);
  const { createEncarte } = useCreateEncarte({ token, setNotification });
  const [latestThemes, setLatestThemes] = useState([]);
  const [loading, setLoading] = useState(true);

  const deviceType = useDeviceType();
  const themeSize =
    deviceType === "mobile"
      ? 8
      : deviceType === "tablet" || deviceType === "laptop"
        ? 10
        : 12;

  const fetchLatestThemes = useFetchLatestThemes();

  useEffect(() => {
    setLoading(true);
    fetchLatestThemes(token, 0, themeSize)
      .then(({ resources }) => {
        setLatestThemes(resources);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setNotification({
          message: "Não foi possível carregar os temas mais recentes",
          type: "error",
        });
        setLoading(false);
      });
  }, [token]);
  const navigate = useNavigate();
  const handleOnUseTheme = (theme) => {
    const newEncarte = Encarte();
    newEncarte.modelUrl = theme.url;
    createEncarte(newEncarte);
  };

  if (loading) return <Loading txt={"Carregando temas"} size={"1.2"} />;

  return (
    <HomeLatestThemesPreviewContainer>
      {notification && (
        <Notification message={notification.message} type={notification.type} />
      )}
      <ThemesPreviewContainer>
        {latestThemes?.map((theme) => (
          <CardAndButtonWrapper key={theme.id}>
            <EncarteCard
              url={theme.urlTmp}
              name={theme.name?.split(".")[0]}
              isIncludedInPlan={isAccountPremium || !theme.isPremiumResource}
              showPremiumTag={
                (!isAccountPremium && theme.isPremiumResource) ||
                (theme.isPremiumResource && accountStatus?.onTrial)
              }
              className={"theme-preview-card"}
            />
            <Button
              text={"Usar tema"}
              size={"1.2"}
              $fullWidth
              $NoBgColor={true}
              action={() => {
                if (isAccountPremium || !theme.isPremiumResource)
                  handleOnUseTheme(theme);
                else navigate("/planos");
              }}
            />
          </CardAndButtonWrapper>
        ))}
      </ThemesPreviewContainer>
    </HomeLatestThemesPreviewContainer>
  );
}
